import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './breaking-news.css';
import '../page-teaser/page-teaser.js';

/**
 * @property {string} headline
 * @property {PageTeaserProperties[]} cards
 */
export default class BreakingNews extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            cards: [],
        };
    }

    template() {
        const cardsWrapperWidth = this.cards.length <= 1 ? 'md:max-w-[360px]' : 'md:max-w-[768px]';
        return html`
            <div class="md:bg-green-light25 rounded-[24px] md:p-fix-s">
                <div class="flex flex-col md:flex-row md:items-center md:justify-center gap-fix-m md:gap-fix-xl">
                    ${when(
                        this.headline,
                        html`<h3 class="fix-title3-medium m-0 text-green-medium hidden lg:block shrink-0">
                            ${this.headline}
                        </h3>`,
                    )}
                    <div
                        class="w-full md:flex-1 ${cardsWrapperWidth} flex flex-col md:flex-row md:justify-center gap-fix-m"
                    >
                        ${this.cards.map(
                            (page) => html`
                                <mb-page-teaser
                                    variant="compact"
                                    .page="${page}"
                                    class="w-full md:flex-1 md:max-w-[360px] shrink-0"
                                ></mb-page-teaser>
                            `,
                        )}
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-breaking-news', BreakingNews);
